var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sup',[_c('v-icon',{staticStyle:{"text-shadow":"none"},attrs:{"small":"","color":_vm.getSocialiteColor(_vm.driver)}},[_vm._v(_vm._s(_vm.getSocialiteIcon(_vm.driver)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }